<template>
	<div ref="tablePage" style="height: 100%">
		<!-- 面包屑导航 -->
		<div class="topNav">
			<div class="navFormWrapper">
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item :to="{ path: '/homePage' }">首页</el-breadcrumb-item>
					<el-breadcrumb-item>城市管理</el-breadcrumb-item>
				</el-breadcrumb>
				<el-form ref="queryForm" :model="searchForm" inline label-width="68px" style="margin-left: 8vh">
					<el-form-item style="margin-bottom: 0">
						<el-input v-model="searchForm.title" autocomplete="off" maxlength="30" placeholder="城市名称"
							clearable size="small" @change="searchChange" />
					</el-form-item>
					<el-form-item style="margin-bottom: 0">
						<el-button type="primary" icon="el-icon-search" @click="searchChange"
							size="small">搜索</el-button>
						<el-button icon="el-icon-plus" type="success" @click="handleNewAdd"
							size="small">新增城市</el-button>
					</el-form-item>
				</el-form>
			</div>
		</div>
		<!-- <el-button
      type="primary"
      icon="el-icon-plus"
      @click="handleNewAdd"
      size="mini"
      style="margin-top: 2vh"
      >新增城市</el-button
    > -->
		<el-table :data="tableList" style="width: 100%; margin-top: 2vh" border size="medium" :header-cell-style="{
        background: '#fff',
        height: '50px',
        color: '#909399',
        fontSize: '16px',
        fontFamily: 'Arial, sans-serif',
      }">
			<el-table-column prop="sort" label="排序" align="center" sortable />
			<el-table-column prop="title" label="城市名称" align="center" />
			<el-table-column prop="pinyin" label="拼音" align="center" />
			<el-table-column prop="content" label="备注" align="center" />
			<el-table-column prop="status" label="热门" align="center">
				<template slot-scope="scope">
					<el-switch v-model="scope.row.is_hot" :active-value="1" :inactive-value="0" active-color="#13ce66"
						@change="changeStatus(scope.row)"></el-switch>
				</template>
			</el-table-column>
			<el-table-column prop="status" label="状态" align="center">
				<template slot-scope="scope">
					<el-switch v-model="scope.row.status" :active-value="1" :inactive-value="0"
						@change="changeStatus(scope.row)"></el-switch>
				</template>
			</el-table-column>
			<el-table-column fixed="right" label="操作" align="center">
				<template slot-scope="scope">
					<el-button @click.native.prevent="handleClick(scope.row)" type="primary" size="small"
						icon="el-icon-edit">
						修改
					</el-button>
					<el-button @click.native.prevent="singleDel(scope.row, scope.row.id)" type="danger" size="small"
						icon="el-icon-delete">
						移除
					</el-button>
				</template>
			</el-table-column>
		</el-table>
		<pagination v-show="total > 0" :total="total" :page.sync="searchForm.page" :limit.sync="searchForm.size"
			@pagination="initList" />
		<el-dialog :title="title" :visible.sync="addOrEditOpen" :close-on-click-modal="false" width="30%"
			class="global-dialog-position" :before-close="getout">
			<el-form ref="form" :model="form" label-width="80px" :rules="rules">
				<el-row>
					<el-col :span="24">
						<el-form-item label="城市名称" prop="title">
							<el-input v-model="form.title" autocomplete="off" placeholder="请输入" />
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="排序" prop="sort">
							<el-input v-model="form.sort" autocomplete="off" placeholder="请输入" type="number" />
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="首字母" prop="initial">
							<el-input v-model="form.initial" autocomplete="off" placeholder="请输入" />
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="拼音" prop="pinyin">
							<el-input v-model="form.pinyin" autocomplete="off" placeholder="请输入" />
						</el-form-item>
					</el-col>
					<!-- <el-col :span="24">
            <el-form-item label="是否热门" prop="is_hot">
              <el-radio-group v-model="form.is_hot">
                <el-radio
                  v-for="item in ishot"
                  :label="item.label"
                  :key="item.label"
                  >{{ item.text }}</el-radio
                >
              </el-radio-group>
            </el-form-item>
          </el-col> -->
					<!-- <el-col :span="24">
            <el-form-item label="状态" prop="status">
              <el-radio-group v-model="form.status">
                <el-radio
                  v-for="item in regionTypes"
                  :label="item.label"
                  :key="item.label"
                  >{{ item.text }}</el-radio
                >
              </el-radio-group>
            </el-form-item>
          </el-col> -->
					<el-col :span="24">
						<el-form-item label="备注说明">
							<el-input v-model="form.content" type="textarea" autocomplete="off" />
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="submitForm">确 定</el-button>
				<el-button @click="getout">取 消</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import tableCommon from "../../../mixins/table-common";
	import {
		getCityeList,
		addCity,
		editCity,
		deleteCity
	} from "../../api/city";
	export default {
		mixins: [tableCommon],
		data() {
			return {
				regionTypes: [{
						label: 1,
						text: "启用",
					},
					{
						label: 0,
						text: "停用",
					},
				],
				ishot: [{
						label: 1,
						text: "是",
					},
					{
						label: 0,
						text: "否",
					},
				],
				// 请求地址api
				api: {
					list: getCityeList,
					add: addCity,
					del: deleteCity,
					edit: editCity,
				},
				// 规则验证
				rules: {
					title: [{
						required: true,
						message: "请输入城市名称",
						trigger: "blur"
					}],
					sort: [{
						required: true,
						message: "请输入排序",
						trigger: "blur"
					}],
					pinyin: [{
						required: true,
						message: "请输入城市的拼音",
						trigger: "blur"
					}],
					status: [{
						required: true,
						message: "请选择",
						trigger: "change"
					}],
					is_hot: [{
						required: true,
						message: "请选择",
						trigger: "change"
					}],
					initial: [{
						required: true,
						pattern: /^[A-Z]$/,
						message: "只允许输入城市名的大写首字母",
						trigger: "blur",
					}, ],
				},
				// 传参
				form: {
					status: "1",
				},
				// 弹窗标题
				title: "新增",
				addOrEditOpen: false,
				// 查询参数
				searchForm: {
					page: 1,
					size: 10,
				},
				tableData: [],
			};
		},
		methods: {
			// 改变状态
			changeStatus(res) {
				this.form = JSON.parse(JSON.stringify(res));
				// this.handleEdit();
				this.actionType = "edit";
				editCity(this.form).then((msg) => {
					if (msg.code !== 200) return this.$message("获取状态失败");
				});
			},
			// 重置
			reset() {
				this.form = {
					status: undefined,
					title: undefined,
				};
			},
			// 新增弹窗
			handleNewAdd() {
				this.title = "新增";
				this.reset();
				this.$nextTick(() => {
					this.form.status = 1;
					this.form.is_hot = 1;
					this.$refs.form.clearValidate();
				});
				this.handleAdd();
			},
			// 修改弹窗
			handleClick(row) {
				this.title = "修改";
				this.form = JSON.parse(JSON.stringify(row));
				this.handleEdit();
			},
			// 重置
			resets() {
				this.searchForm = {
					title: undefined,
				};
				this.initList();
			},
			// 关闭弹窗
			getout() {
				this.addOrEditOpen = false;
				this.$refs.form.clearValidate();
			},
		},
	};
</script>

<style scoped>
	/deep/.el-table,
	.el-table th,
	.el-table td {
		border-radius: 10px;
		-webkit-font-smoothing: antialiased;
		text-rendering: optimizeLegibility;
		font-size: 16px;
		font-family: Times, "Times New Roman";
		/* font-weight: 600; */
	}

	.topNav {
		display: flex;
		align-items: center;
		justify-content: space-between;
		background: #fff;
		padding: 20px 20px;
		border-radius: 10px;
	}

	.navFormWrapper {
		display: flex;
		align-items: center;
	}
</style>


// WEBPACK FOOTER //
// src/views/citys/index.vue